import PanoramicImage from './PanoramicImage';

export default PanoramicImage;
